import React from 'react';
import {
  getQuizDisplayTitle,
  getQuizDisplayTheme,
  type QuizCardTextLike,
} from '../utils/quizDisplayTitle';

type Props = {
  quiz: QuizCardTextLike;
  language: string;
};

/**
 * Lobby card: main title on the first line, optional theme on the second (muted).
 */
const QuizTwoLineHeading: React.FC<Props> = ({ quiz, language }) => {
  const title = getQuizDisplayTitle(quiz, language);
  const theme = getQuizDisplayTheme(quiz, language);
  return (
    <>
      <span className="quiz-card-solo-title-text">{title}</span>
      {theme ? (
        <span className="quiz-card-solo-theme-text d-block small text-muted mt-1">{theme}</span>
      ) : null}
    </>
  );
};

export default QuizTwoLineHeading;
